import { isYtbRoutePath } from '@/router/lib/route-prefix.js'

/** YTB 站点标签页标题与 favicon，与主站 Easy Work 互斥切换 */

export const YTB_SITE_TITLE = 'AI 自动出片工具箱'

const APP_SITE_TITLE = 'Easy Work'
const APP_FAVICON_HREF = '/favicon.ico'
const YTB_FAVICON_HREF = '/ytb-favicon.svg'

function setFavicon(href) {
  let link = document.querySelector('link[rel="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  if (link.getAttribute('href') !== href) {
    link.setAttribute('href', href)
  }
}

/** 按当前路由同步 document.title 与 favicon */
export function syncDocumentBranding(route) {
  const path = route?.path || ''
  if (isYtbRoutePath(path)) {
    const pageTitle = String(route.meta?.documentTitle || '').trim()
    document.title = pageTitle ? `${pageTitle} · ${YTB_SITE_TITLE}` : YTB_SITE_TITLE
    setFavicon(YTB_FAVICON_HREF)
    return
  }

  document.title = APP_SITE_TITLE
  setFavicon(APP_FAVICON_HREF)
}

/** YTB 独立构建：首屏即应用 YTB 品牌 */
export function initYtbStandaloneBranding() {
  document.title = YTB_SITE_TITLE
  setFavicon(YTB_FAVICON_HREF)
}
